import BillingDeliveryPanel from './BillingDeliveryPanel';

export default BillingDeliveryPanel;
